import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { first, switchMap, take } from 'rxjs/operators';
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';

import { KycComponent } from '../kyc/kyc.component';
import { OtpverificationComponent } from '../otpverification/otpverification.component';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { CommonService } from '../../../_common/_service/user.service';


@Component({
  selector: 'app-add-card',
  templateUrl: './add-card.component.html',
  styleUrls: ['./add-card.component.scss']
})

export class AddcardComponent implements OnInit {
  currentDate = new Date();
  Idprooflist: any;
  Cardprooflist: any;
  loadingspinner: boolean = false;
  submitted = false;
  myFiles: string[] = [];
  imgURLCard: any = '';
  imgURLId: any = '';
  imgURLIdback: any = '';
  imgURLIdfnt: any = '';

  cardImage: any;
  idProofImage: any;

  IdCrDeImagefnt: any;
  IdCrDeImageBACK: any;

  warning: any;
  kycRemarkStatus: any;

  isLoggedIn = false;
  msg1: any;
  msg2: any;
  msg3: any;
  msg4: any;
  btn: any;
  currentUser: any;

  public kycForm: FormGroup;

  constructor(private readonly adapter: DateAdapter<Date>, public datepipe: DatePipe, private fb: FormBuilder, private toastr: ToastrService, private tokenStorageService: TokenStorageService, public dialog: MatDialog,
    private authService: AuthService, private _service: AuthenticationService, public dialogRef: MatDialogRef<AddcardComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private ref: ChangeDetectorRef, private tokenService: AuthenticationService, private _service1: CommonService) {
    this.adapter.setLocale('en-GB'); //dd/MM/yyyy
    this.adapter.format(this.currentDate, "MM/YYYY");
    this.kycForm = this.fb.group({
      KycType1: [null, [Validators.required]],
      CardNumber: [null, [Validators.required, Validators.minLength(19)]],
      kycExpiry1: [null, [Validators.required]]
    })
  }

  ngOnInit() {
    
    //this.isLoggedIn = !!this.tokenStorageService.getToken();

    //if (this.isLoggedIn) {

    this.imgURLCard = '../../../../assets/Images/imgId.png';
    this.currentUser = this.tokenStorageService.getUser();

    this.getCardprooflist();

  }

  get f() { return this.kycForm.controls; }


  transform() {
    let transformValue = this.f.CardNumber.value;

    if (transformValue && transformValue.length > 0) {
      let chIbn = transformValue.split('-').join('');
      if (chIbn.length > 0) {
        chIbn = chIbn.match(new RegExp('.{1,4}', 'g')).join('-');
      }

      this.f.CardNumber.setValue(chIbn);
    }
  }

  upload() {
    this.submitted = true;
   
      if (!this.cardImage) {

        
        this.msg2 = "No File Selected";
        
        return;
      }
      if (!this.cardImage) {
        this.msg2 = "No File Selected";
        return;
      }
    
   

   
    if (this.kycForm.invalid) {
      return;
    }


    const formdata: FormData = new FormData();

    if (this.cardImage) {
      this.myFiles.push(this.cardImage);
    }
    
    // var cardNo = this.f.First6Number.value + 'XXXXXX' + this.f.Last6Number.value;
    
    var dt2 = this.datepipe.transform(this.f.kycExpiry1.value, 'yyyy-MM-dd');
    // 111111XXXXXX2222 
    for (var i = 0; i < this.myFiles.length; i++) {
      if (i == 0) {
        formdata.append("Image", this.myFiles[i]);
        formdata.append("ImageType", "CARD");

        formdata.append("KycType", this.f.KycType1.value);
        formdata.append("Number", this.f.CardNumber.value);
        formdata.append("kycExpiry", dt2 ? dt2 : '');
      }

    }

    this.loadingspinner = true;
    // 
    this.authService.addMobileMoneyRequestuploadcardImage(formdata).subscribe(response => {
      this.loadingspinner = false;
      this.dialogRef.close();
      this.cardImage = '';
      this.imgURLCard = '';
      
      if (response.apiStatus == true) {
        this.toastr.success(response.apiMessage, 'Success');
        this.dialogRef.close(true);

      }
      else if (response.apiStatus == false) { //    "apiMessage": "user account is disable",
        this.toastr.warning(response.apiMessage, 'Warning');
        this._service1.callMethodOfSecondComponent();
      }
      else {
        this.toastr.error(response.apiMessage, 'Error');
      }
     
    }, (err: any) => {
      this.loadingspinner = false;
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }

 

  preview(files: any, type: any) {
    
    if (files.length === 0) {
      this.toastr.error('No file', 'Error');
      return;
    }

    if (files[0].size > 50000000) {
      this.toastr.error('maximum file size of 50MB', 'Error');
      return;
    }

    const URL = window.URL || window.webkitURL;
    const Img = new Image();

    Img.src = URL.createObjectURL(files[0]);

    if (files[0].type === 'image/jpeg' || files[0].type === 'image/png' || files[0].type === 'image/jpg') {

      if (type === 2) {
        this.cardImage = files[0];
        ////////console.log(files[0]);
        this.imgURLCard = '';
      }
      var reader = new FileReader();
      //this.imagePath = files;      

      reader.readAsDataURL(files[0]);
      reader.onload = (e: any) => {

        Img.onload = (e: any) => {


          if (type === 2) {
            this.imgURLCard = reader.result;
          }
        }
      }
    }
    else {
      this.toastr.error('Only images are supported.', 'Error');
      return;
    }

  }



  getCardprooflist() {


    this.authService.KYClist(2).subscribe(response => {


      if (response) {
        this.Cardprooflist = response;
      }
      else {
        this.toastr.error('Error', 'Error');
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }




}

export class CustomDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: any): string {
    //const days = date.getDate();
    const months = date.getMonth() + 1;
    const year = date.getFullYear();
    //return days + '-' + months + '-' + year;
    return months + '/' + year;
  }
}
